import { useState, useRef } from "react";
import router from "next/router";
import Image from "next/image";

import UserMenu, { type UserMenuItem, type Portal } from "./UserMenu/UserMenu";
import Notifications from "./Notifications/Notifications";
import SideBar, { type PageLink } from "./SideBar/SideBar";
import { Icon } from "common/ui/Icon";
import { Stack } from "common/ui/Stack";
import { ChatNotifications } from "./ChatNotifications/ChatNotifications";

import { useClickOutside } from "common/middleware/hooks";

import styles from "./NavigationBar.module.scss";
import logo from "common/assets/ownspace.png";

export interface NavigationBarProps {
  menu: PageLink[],
  userMenu?: UserMenuItem[],
  portal: Portal,
}

export function NavigationBar({
  menu,
  userMenu,
  portal,
}: NavigationBarProps) {
  const [showSideBar, setShowSideBar] = useState(false);

  const sideBar = useRef(null);

  useClickOutside(sideBar, () => setShowSideBar(false));

  return (
    <>
      <div className={styles.NavigationBar}>
        <div className={styles.LeftContainer}>
          <div className={styles.Icons}>
            <Icon
              icon="backMajor"
              onClick={router.back}
              ariaLabel="back"
            />
            <Icon
              icon="menuMajor"
              onClick={() => setShowSideBar(!showSideBar)}
              ariaLabel="menu-icon"
            />
          </div>
          <Image
            className={styles.OwnSpace}
            src={logo}
            alt="ownspace logo"
            priority
          />
        </div>
        <Stack gap={24} alignItems="center">
          {["seller", "buyer"].includes(portal) && (
            <ChatNotifications />
          )}
          {["seller", "buyer", "auth"].includes(portal) && (
            <Notifications />
          )}
          <UserMenu
            menuItems={userMenu}
            portal={portal}
          />
        </Stack>
      </div>
      <SideBar
        ref={sideBar}
        isOpen={showSideBar}
        close={() => setShowSideBar(false)}
        links={menu}
      />
    </>
  );
}
